import React from 'react';

/** Base skeleton block with pulse animation */
export function Skeleton({ className = '', ...props }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-muted/60 ${className}`}
      {...props}
    />
  );
}

/** Skeleton row matching the project list item layout */
export function ProjectRowSkeleton() {
  return (
    <div className="grid grid-cols-12 gap-4 px-5 py-3 items-center">
      <div className="col-span-5 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/4" />
      </div>
      <div className="col-span-2">
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <div className="col-span-2">
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <div className="col-span-1 flex justify-end">
        <Skeleton className="h-4 w-10" />
      </div>
      <div className="col-span-2 flex justify-end">
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  );
}

/** Skeleton card matching StatsCard layout */
export function StatsCardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-4 space-y-3">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-4 w-4 rounded" />
      </div>
      <Skeleton className="h-7 w-12" />
    </div>
  );
}

/** Skeleton for the recent project rows on dashboard */
export function DashboardRowSkeleton() {
  return (
    <div className="flex items-center justify-between px-5 py-3">
      <div className="flex-1 min-w-0 space-y-2">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/3" />
      </div>
      <Skeleton className="h-5 w-16 rounded-full ml-4" />
    </div>
  );
}
